import Input from "../../../../components/FormComponents/Input";

const GmailApiConfig = ({ data, onChange }) => {
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    onChange({ ...data, [name]: value });
  };

  return (
    <div className={"d_flex flex_column gap_3"}>
      <Input
        name="access_token"
        value={data.access_token}
        onChange={handleInputChange}
        placeholder="Paste your Gmail API access token"
        label="Access Token"
      />
    </div>
  );
};
export default GmailApiConfig;
